export default "__VITE_ASSET__62f173d9__"